import { TRANSACTION_DIRECTION } from './constants';

export const formatTransactionAmount = (direction, amount, isPayment = false) => {
  const isCredit = direction === TRANSACTION_DIRECTION.CREDIT;
  // Positive condition simplified: Credit not a payment, or Debit that is a payment.
  const shouldPrefixPlus = isCredit !== isPayment;

  return shouldPrefixPlus ? `+${amount}` : amount;
};
